import React from "react";
import { Controller } from "react-hook-form";

export default function SelectField({
  control,
  label,
  options,
  name,
  className,
  defaultValue,
  rules,
  errors,
  onChange,
  size,
  customDefaultOption,
  ...rest
}) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      errors={errors}
      render={({ field, fieldState:{  invalid } }) => {
        const isDefaultOption =
          field.value === "Please Choose" ||
          (customDefaultOption && field.value === customDefaultOption.value) ||
          !field.value;
        return (
          <div
            className={`checkout-form__field checkout-form__${name}${
              size ? ` ${size}` : ""
            }${invalid ? " has-errors" : ""}`}
          >
            <label>{label}</label>
            <select
              {...rest}
              {...field}
              onChange={(e) => {
                if (typeof onChange !== "undefined") {
                  onChange(e);
                } else {
                  field?.onChange(e);
                }
              }}
              aria-label={label}
              className={`${className ? className : ""}${
                isDefaultOption ? " default-option" : ""
              }`}
              defaultValue={defaultValue}
            >
              {(customDefaultOption && (
                <option key="default" value={customDefaultOption.value}>
                  {customDefaultOption.label}
                </option>
              )) || (
                <option key="default" value={!rules ? "Please Choose" : ""}>
                  Please Choose
                </option>
              )}
              {options.map((option) => (
                <option
                  key={option.value}
                  value={option.value}
                  disabled={option.disabled}
                >
                  {option.label}
                </option>
              ))}
            </select>
            {errors && errors[name] && errors[name].type === "required" && (
              <span
                role="alert"
                className="help-tip help-tip--top-left help-tip--form-field"
              >
                {rules.required}
              </span>
            )}
          </div>
        );
      }}
    />
  );
}
